<template>
  <div class="min-w-0 flex-1 md:grid md:grid-cols-2 md:gap-4">
    <div>
      <p class="text-sm font-medium text-neutral-800">
        <slot name="primaryLabel">
          {{ primaryLabel }}
        </slot>
      </p>
      <p class="mt-2 flex items-center text-sm text-neutral-500">
        <span class="truncate">
          <slot name="secondaryLabel">
            {{ secondaryLabel }}
          </slot>
        </span>
      </p>
    </div>
    <slot name="additionalInfo"></slot>
  </div>
</template>

<script lang="ts">
// Note: When updating this description - you must also update the md file.

/** A list item that can be displayed in a LandingCardEntityList. */
export default { name: "LandingCardEntityListItem" };
</script>

<script setup lang="ts">
const props = defineProps<{
  primaryLabel?: string | number | null;
  secondaryLabel?: string | number | null;
}>();
</script>
